import React, { useState } from 'react';

interface PDFFile {
  id: number;
  name: string;
  thumbnail: string; // URL or base64 string of the thumbnail image
}

interface TabsWithThumbnailsProps {
  files: PDFFile[];
}

const TabsWithThumbnails: React.FC<TabsWithThumbnailsProps> = ({ files }) => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div>
      <div className="tabs">
        {files.map((file, index) => (
          <button
            key={file.id}
            className={`tab ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
          >
            <img src={file.thumbnail} alt={file.name} className="thumbnail" />
            <span>{file.name}</span>
          </button>
        ))}
      </div>
      <div className="tab-content">
        {files.length > 0 ? (
          <p>Selected File: {files[activeTab].name}</p>
        ) : (
          <p>No PDF files available</p>
        )}
      </div>
    </div>
  );
};

export default TabsWithThumbnails;